export const INITIAL_STATE = {
  name: '',
  description: '',
  images: [],
};
